import React, { useEffect, useState } from "react";
import { EmptyState } from "../../../../../../components/EmptyState/EmptyState";
import {
  INTERNAL_GRADE_IT_LABEL,
  COURSE_CERTIFICATE_LABEL,
  COURSE_LABEL,
  COURSES_LABEL,
  DELETE_COURSE_BODY_LABEL_1,
  DELETE_COURSE_BODY_LABEL_2,
  DELETE_COURSE_LABEL,
  DESCRIPTION_LABEL,
  EMPTY_COURSES_SELECTED_LABEL,
  EXECUTION_MODE_LABEL,
  GROUP_TARGETS_LABEL,
  NAME_LABEL,
  URL_LABEL,
  EMPTY_COURSES_MESSAGE,
  RECIPIENT_LABEL,
  EMPTY_STRING,
  ITEMS_ADDED_SUCCESS_LABEL,
  DATA_UPDATED_SUCCESS_LABEL,
  DATA_DELETED_SUCCESS_LABEL,
} from "../../../../../../constants/Dictionary";
import coursesImage from "../../../../../../images/courses.png";
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from "../../../../../../components/core/Button/Button";
import { TableFormationCM } from "../TableFormationCM/TableFormationCM";
import { getCollaboratorCoursesPageColumns } from "../../../../../../constants/TableColumns";
import {
  ReactComponent as AddIcon,
  ReactComponent as PlusIcon,
} from "../../../../../../icons/add.svg";
import { AddCollaboratorCourses } from "./AddCourseModal/AddCollaboratorCourses";
import {
  AlignmentEnum,
  FontWeightEnum,
} from "../../../../../../types/AppTypes";
import { useSearchParams } from "react-router-dom";
import { CollaboratorCmSheetCourse } from "../../../../../../types/api/collaborators.type";
import { BodyTyp } from "../../../../../../components/Typography/Typography";
import {
  EmptyStateContainer,
  StyledFormationCM,
} from "../TableFormationCM/TableFormationCM.styled";
import { DoubleStructure } from "../../../../../../components/core/DoubleStructure/DoubleStructure";
import SearchInput from "../../../../../../components/core/SearchInput/SearchInput";
import {
  Link,
  LinkSizeEnum,
} from "../../../../../../components/core/Link/Link";
import { PopupConfirm } from "../../../../../../components/PopupConfirm/PopupConfirm";
import { CertificateModal } from "../../../../../../components/CertificateModal/CertificateModal";
import { EditCollaboratorCourseCertificateModal } from "./EditCourseCertificateModal/EditCourseCertificateModal";
import { CmSheetFooter } from "../../Components/CmSheetFooter/CmSheetFooter";
import { Loader } from "../../../../../../components/core/Loader/Loader";
import { useAppSelector } from "../../../../../../hooks/store.hook";
import {
  TextBoxGrid,
  TextBox,
} from "../../../../../../components/TextBoxGrid/TextBoxGrid.component";
import { OperationEnum } from "../../../../../../types/api/generic.type";
import { findLabelFromValue } from "../../../../../../utils/orgFunctions.utils";
import { Course } from "../../../../../../types/api/courses.type";
import TargetGroups from "../../../../../../components/TargetGroups/TargetGroups";
import CmSheetCertificateOfCoursesService from "../../../../../../services/api/cmSheet/CmSheetCertificateOfCourse.service";
import { CmSheetSectionProps } from "../../SchedaCM";
import { roleHasPermission } from "../../../../../../utils/roleAuth.utils";
import {
  DETAIL_QUERY_PARAM_KEY,
  decodeParams,
} from "../../../../../../utils/queryParams.utils";
import {
  CmSheetStateEnum,
  PermissionsEnum,
} from "../../../../../../constants/AppConstants";
import {
  useCmSheetCourses,
  useUpdateCmSheetCourses,
} from "../../../../../../hooks/cmSheet/courses.hook";
import { useDeleteCmSheetCourseCertificate } from "../../../../../../hooks/cmSheet/courseCertificate.hook";

export const CollaboratorCourses = ({
  setHeaderRightContent,
  footer,
  cmSheetInfo,
  isMyProfile,
  cmSheetStateMachineInfo,
  showFooter,
  isInterim,
}: CmSheetSectionProps) => {
  const [searchParams] = useSearchParams();
  const queryParams = decodeParams(searchParams.get(DETAIL_QUERY_PARAM_KEY));
  const collaboratorName = queryParams.collaboratorName ?? null;
  const collaboratorSurname = queryParams.collaboratorSurname ?? null;

  const { orgSettings } = useAppSelector((state) => state.config);
  const { profile } = useAppSelector((state) => state.user);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [selectedCourse, setSelectedCourse] =
    useState<CollaboratorCmSheetCourse | null>(null);
  const [hasData, setHasData] = useState<boolean | null>(null);
  const [searchValue, setSearchValue] = useState("");

  const certificateApi = (courseId: number) =>
    CmSheetCertificateOfCoursesService.get(cmSheetInfo.id, courseId);

  const { deleteCourseCertificate, isDeleting: deleting } =
    useDeleteCmSheetCourseCertificate(cmSheetInfo.id);

  const { data, isFetching } = useCmSheetCourses(cmSheetInfo.id);

  const { updateCmSheetCourses, isUpdating: updating } =
    useUpdateCmSheetCourses(cmSheetInfo.id);

  const onSave = async (saveData: Course[]) => {
    try {
      const newCourses = saveData.map((course) => {
        return {
          operation: OperationEnum.ADD,
          entityId: null,
          data: {
            courseId: course.id,
            isFinished: false,
          },
        };
      });
      await updateCmSheetCourses(newCourses, ITEMS_ADDED_SUCCESS_LABEL);
    } finally {
      setHasData(null);
    }
  };

  const onToggle = async (course: CollaboratorCmSheetCourse) => {
    try {
      const updatedCourse = [
        {
          operation: OperationEnum.UPDATE,
          entityId: course.id,
          data: { isFinished: !course.isFinished },
        },
      ];
      await updateCmSheetCourses(updatedCourse, DATA_UPDATED_SUCCESS_LABEL);
    } finally {
      setHasData(null);
    }
  };

  useEffect(() => {
    setHasData(null);
  }, [cmSheetInfo]);

  useEffect(() => {
    if (!isFetching) {
      if (data && hasData === null) {
        const newhasData = data.length > 0;
        setHasData(newhasData);
      }
    }
  }, [data, hasData, isFetching]);

  useEffect(() => {
    footer(
      <CmSheetFooter
        showEdit={false}
        showFooter={showFooter}
        cmSheetInfo={cmSheetInfo}
        cmSheetStateMachineInfo={cmSheetStateMachineInfo}
        isMyProfile={isMyProfile}
        isInterim={isInterim}
      />,
    );
  }, [
    hasData,
    isFetching,
    updating,
    deleting,
    cmSheetInfo,
    cmSheetStateMachineInfo,
  ]);

  const canEdit = () => {
    if (!isMyProfile) {
      if (roleHasPermission(profile, PermissionsEnum.EDIT_ALL_CM_SHEETS)) {
        return true;
      }

      if (
        roleHasPermission(profile, PermissionsEnum.EDIT_OWN_CM_SHEET) &&
        profile.id === cmSheetInfo.careerManagerId &&
        [
          CmSheetStateEnum.DRAFT,
          CmSheetStateEnum.INTERMEDIATE_EVALUATION,
        ].includes(cmSheetStateMachineInfo.currentState)
      ) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    if (canEdit() && hasData) {
      setHeaderRightContent(
        <Link
          onClick={() => setShowAddModal(true)}
          icon={<PlusIcon />}
          size={LinkSizeEnum.SMALL}
          disabled={isFetching || updating || deleting}
        >
          {COURSE_LABEL}
        </Link>,
      );
    } else {
      setHeaderRightContent(null);
    }
  }, [updating, deleting, isFetching, hasData]);

  const onShowCertificate = (course: CollaboratorCmSheetCourse) => {
    setSelectedCourse(course);
    setShowCertificateModal(true);
  };

  const onUploadCertificate = (course: CollaboratorCmSheetCourse) => {
    setSelectedCourse(course);
    setShowEditModal(true);
  };

  const onDelete = (course: CollaboratorCmSheetCourse) => {
    setShowDeleteModal(true);
    setSelectedCourse(course);
  };

  const expandRow = (
    record: CollaboratorCmSheetCourse,
  ): React.ReactElement | null => {
    return (
      <>
        {!record.course.adHocCollaborator && (
          <TextBoxGrid
            numCol={2}
            items={[
              {
                label: GROUP_TARGETS_LABEL,
                text: <TargetGroups cc={record.course.cc} />,
              },
              {
                label: INTERNAL_GRADE_IT_LABEL,
                text: record.course.internalGrade
                  ? record.course.internalGrade.join(", ")
                  : EMPTY_STRING,
              },
            ]}
          />
        )}
        {record.course.adHocCollaborator ? (
          <TextBoxGrid
            numCol={3}
            items={[
              {
                label: RECIPIENT_LABEL,
                text: record.course.collaborator
                  ? `${record.course.collaborator?.surname} ${record.course.collaborator?.name}`
                  : EMPTY_STRING,
              },
              {
                label: EXECUTION_MODE_LABEL,
                text: findLabelFromValue(
                  orgSettings.courses.executionModes,
                  record.course.executionMode,
                ),
              },
              {
                label: URL_LABEL,
                text: record.course.url,
              },
            ]}
          />
        ) : (
          <TextBoxGrid
            numCol={2}
            items={[
              {
                label: EXECUTION_MODE_LABEL,
                text: findLabelFromValue(
                  orgSettings.courses.executionModes,
                  record.course.executionMode,
                ),
              },
              {
                label: URL_LABEL,
                text: record.course.url,
              },
            ]}
          />
        )}
        <TextBox label={DESCRIPTION_LABEL} text={record.course.description} />
      </>
    );
  };

  const rowKey = (record: CollaboratorCmSheetCourse) => {
    return record.course.id.toString();
  };

  const emptyState = (isLoading: boolean) => {
    return (
      <EmptyStateContainer>
        {isLoading ? (
          <Loader loading={isLoading} />
        ) : (
          <EmptyState
            label={canEdit() ? EMPTY_COURSES_SELECTED_LABEL : ""}
            imageSrc={coursesImage}
          >
            {canEdit() && (
              <Button
                label={COURSE_LABEL}
                variant={ButtonVariants.SECONDARY}
                size={ButtonSizes.REGULAR}
                icon={<AddIcon />}
                onClick={() => setShowAddModal(true)}
              />
            )}
          </EmptyState>
        )}
      </EmptyStateContainer>
    );
  };

  const handleDeleteCertificate = async (course: CollaboratorCmSheetCourse) => {
    try {
      await deleteCourseCertificate(course.id);
    } finally {
      setHasData(null);
      setShowCertificateModal(false);
      setSelectedCourse(null);
    }
  };

  const handleDeleteCourse = async () => {
    try {
      if (!selectedCourse) {
        return;
      }
      const updatedCourse = [
        {
          operation: OperationEnum.DELETE,
          entityId: selectedCourse.id,
          data: null,
        },
      ];
      await updateCmSheetCourses(updatedCourse, DATA_DELETED_SUCCESS_LABEL);
    } finally {
      setHasData(null);
      setShowDeleteModal(false);
      setSelectedCourse(null);
    }
  };

  const filterData = (data: CollaboratorCmSheetCourse[]) => {
    return searchValue
      ? data.filter((item) =>
          item.course.name.toLowerCase().includes(searchValue.toLowerCase()),
        )
      : data;
  };

  const filteredData = data ? filterData(data) : [];

  return (
    <>
      {showAddModal && (
        <AddCollaboratorCourses
          isOpen={showAddModal}
          onConfirm={onSave}
          cmSheetInfo={cmSheetInfo}
          closeModal={() => setShowAddModal(false)}
        />
      )}
      {selectedCourse && (
        <CertificateModal
          isOpen={showCertificateModal}
          label={COURSE_CERTIFICATE_LABEL}
          onDelete={
            canEdit()
              ? () => handleDeleteCertificate(selectedCourse)
              : undefined
          }
          closeModal={() => {
            setShowCertificateModal(false);
            setSelectedCourse(null);
          }}
          {...(selectedCourse && {
            certificateApi: () => certificateApi(selectedCourse.id),
          })}
          idKeyApi={`collaborator-course-${selectedCourse.id}`}
        />
      )}
      {selectedCourse && (
        <EditCollaboratorCourseCertificateModal
          isOpen={showEditModal}
          course={selectedCourse}
          cmSheetInfo={cmSheetInfo}
          closeModal={() => {
            setShowEditModal(false);
            setSelectedCourse(null);
          }}
        />
      )}
      {selectedCourse && (
        <PopupConfirm
          isOpen={showDeleteModal}
          label={DELETE_COURSE_LABEL}
          popupText={`${DELETE_COURSE_BODY_LABEL_1} ${selectedCourse.course.name} ${DELETE_COURSE_BODY_LABEL_2} ${collaboratorSurname} ${collaboratorName}?`}
          isLoading={updating}
          onConfirm={handleDeleteCourse}
          onCancel={() => {
            setShowDeleteModal(false);
            setSelectedCourse(null);
          }}
        />
      )}
      {!hasData ? (
        emptyState(isFetching || updating || deleting)
      ) : (
        <StyledFormationCM>
          <div className="cm-formation-header-container">
            <DoubleStructure
              verticalAlignment={AlignmentEnum.CENTER}
              variant="primary"
            >
              <BodyTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
                {`${filteredData.length} ${filteredData.length === 1 ? COURSE_LABEL : COURSES_LABEL}`}
              </BodyTyp>
              <div className="filters">
                <SearchInput
                  value={searchValue}
                  onChange={setSearchValue}
                  label={NAME_LABEL}
                  name={"search"}
                />
              </div>
            </DoubleStructure>
          </div>
          <TableFormationCM<CollaboratorCmSheetCourse>
            data={filteredData}
            scrollY={"calc(100dvh - 490px)"}
            loading={isFetching}
            headers={getCollaboratorCoursesPageColumns(
              onShowCertificate,
              isMyProfile ?? false,
              orgSettings,
              canEdit() ? onUploadCertificate : undefined,
              canEdit() ? onToggle : undefined,
            )}
            {...(canEdit() && {
              onDelete: onDelete,
            })}
            expandable={{
              expandedRowRender: expandRow,
            }}
            rowKey={rowKey}
            emptyText={EMPTY_COURSES_MESSAGE}
          />
        </StyledFormationCM>
      )}
    </>
  );
};
